/*
 * @Description: i18n 入口文件
 * @Author: mdb
 * @Date: 2022-05-09 16:21:09
 * @LastEditTime: 2023-03-13 16:49:29
 * @LastEditors: mdb
 */
import { createI18n } from 'vue-i18n'
import { shareInfo } from '@dc-platform/dc-interaction'
const zh = require('../lang/zh-CN.json') // 中文语言包
const en = require('../lang/en-US.json') // 英文语言包

enum SystemLanguageEnum {
  'zh-cn' = 'zh-CN', // 简体中文（为了兼容主应用老版本）
  'en-us' = 'en-US', // 英文(为了兼容主应用老版本)
  'zh-CN' = 'zh-CN', // 简体中文
  'en-US' = 'en-US' // 英文
}

const messages = {
  'zh-CN': zh,
  'en-US': en
}

export const getLanguage = (): string => {
  return SystemLanguageEnum[shareInfo.getLanguage()]
}

const i18n = createI18n({
  legacy: false, // you must set `false`, to use Composition API
  locale: getLanguage(), // 语言标识
  fallbackLocale: 'zh-CN', // 默认语言(中文)
  silentFallbackWarn: true, // 关闭控制台警告
  messages: messages
})

export default i18n
